export default function getParentsUntil(el, parent, selector) {
  const parents = [];
  let parentType = '';
  let selectorType = '';
  let element = el;

  if (parent) {
    parentType = parent.charAt(0);
  }
  if (selector) {
    selectorType = selector.charAt(0);
  }

  // Get matches
  for (; element && element !== document; element = element.parentNode) {
    // Check if parent has been reached
    if (parent) {
      // If parent is a class
      if (parentType === '.') {
        if (element.classList.contains(parent.substr(1))) {
          break;
        }
      }

      // If parent is an ID
      if (parentType === '#') {
        if (element.id === parent.substr(1)) {
          break;
        }
      }

      // If parent is a data attribute
      if (parentType === '[') {
        if (element.hasAttribute(parent.substr(1, parent.length - 1))) {
          break;
        }
      }

      // If parent is a tag
      if (element.tagName.toLowerCase() === parent) {
        break;
      }
    }

    if (selector) {
      // If selector is a class
      if (selectorType === '.') {
        if (element.classList.contains(selector.substr(1))) {
          parents.push(element);
        }
      }

      // If selector is an ID
      if (selectorType === '#') {
        if (element.id === selector.substr(1)) {
          parents.push(element);
        }
      }

      // If selector is a data attribute
      if (selectorType === '[') {
        if (element.hasAttribute(selector.substr(1, selector.length - 1))) {
          parents.push(element);
        }
      }

      // If selector is a tag
      if (element.tagName.toLowerCase() === selector) {
        parents.push(element);
      }
    } else {
      parents.push(element);
    }
  }

  // Return parents if any exist
  if (parents.length === 0) {
    return null;
  }

  return parents;
}
